module.exports = __webpack_public_path__ + "img/orange_092.41cb0b82.png";